import React from 'react';
import CSSZSickLeaveCertificateFormHeadline from './CSSZSickLeaveCertificateFormHeadline';
import CSSZSickLeaveCertificateOutingsFields from '../../CSSZFields/CSSZSickLeaveCertificateOutingsFields';

const CSSZSickLeaveCertificateFormPartE: React.FC = () => {
	return (
		<>
			<CSSZSickLeaveCertificateFormHeadline title='component.CSSZSickLeaveCertificateFormPartE.title' />
			<CSSZSickLeaveCertificateOutingsFields containerName='outings' />
		</>
	);
};

export default CSSZSickLeaveCertificateFormPartE;
